import { SuggestionsTable } from '../components/UserService/SuggestionService/SuggestionsTable.jsx'
import {HeaderService} from '../components/UserService/NavBar/HeaderService.jsx'
export const ServiceView = () => {
  return <>
  <HeaderService/>
  <SuggestionsTable/>
  </>;
};

